// extracted by mini-css-extract-plugin
export default {"label":"tiSWQ","disableNextVideoCheckbox":"FPNxb","enableNextVideoCheckbox":"dXT6E"};